import React from 'react';
import PropTypes from 'prop-types';

import Transition from 'react-transition-group/Transition';
import { TRANSITION_TIMEOUT } from 'common/constants';

/** @var {int} - making form renderer fading transitions quicker than in-product transitions. */
const quickTimeout = TRANSITION_TIMEOUT / 2;

const defaultStyle = {
    transition: `opacity ${quickTimeout}ms ease-in-out`,
};

const transitionStyles = {
    entering: { ...defaultStyle, opacity: 0 },
    entered: { ...defaultStyle, opacity: 1 },
    exiting: { ...defaultStyle, opacity: 0 },
};

/**
 * HOC for views to pass a style prop down to the decorated component for transitioning.
 *
 * @param {React} WrappedComponent
 * @return {function}
 */
export default (WrappedComponent) =>
    class WithAppearTransition extends React.Component {
        static propTypes = {
            in: PropTypes.bool.isRequired,
            appear: PropTypes.bool,
            style: PropTypes.object,
        };

        static defaultProps = {
            appear: false,
            style: undefined,
        };

        render() {
            const { in: inValue, appear: inAppear, style, ...restProps } = this.props;
            return (
                <Transition unmountOnExit mountOnEnter appear={inAppear} in={inValue} timeout={quickTimeout}>
                    {(state) => (
                        <WrappedComponent
                            {...restProps}
                            style={
                                style !== undefined ? { ...style, ...transitionStyles[state] } : transitionStyles[state]
                            }
                        />
                    )}
                </Transition>
            );
        }
    };
